import { ValidationError } from '@multiplier/lib-shared-errors';
import { Injection } from '@multiplier/lib-shared-injection';
import { Result } from '@multiplier/lib-shared-result';
import { z } from 'zod';
/**
 * Enumeration of account classes used for financial categorization
 */
export var AccountClass;
(function (AccountClass) {
    AccountClass["ASSET"] = "ASSET";
    AccountClass["EQUITY"] = "EQUITY";
    AccountClass["EXPENSE"] = "EXPENSE";
    AccountClass["LIABILITY"] = "LIABILITY";
    AccountClass["REVENUE"] = "REVENUE";
})(AccountClass || (AccountClass = {}));
/**
 * Case-normalising Zod schema for `AccountClass`. Accepts any casing and
 * produces the canonical upper-case enum member. Values outside the enum
 * fail parsing.
 */
export const AccountClassSchema = z
    .string()
    .transform((v) => v.toUpperCase())
    .pipe(z.nativeEnum(AccountClass));
/**
 * Injection between `AccountClass` and its canonical string representation.
 * `invert` accepts any string (e.g., values read from a BigQuery row) and
 * fails with `ValidationError` when it's not one of the enum members.
 */
export const accountClassInjection = new Injection((ac) => ac, (s) => {
    const parsed = AccountClassSchema.safeParse(s);
    return parsed.success ? Result.ok(parsed.data) : Result.error(new ValidationError(`Invalid AccountClass: ${s}`));
});
//# sourceMappingURL=AccountClass.js.map